module.exports = __webpack_public_path__ + "img/welfare-item-bg.39a0c697.png";